import { GET_USERS_REPORT, GET_PHRASES_REPORT, GET_WEBSITES_REPORT, GET_SUPERVISOR_REPORT, GET_SUPERVISOR_USER_REPORT, GET_SUPERVISOR_LOGIN_REPORT, GET_SUPERVISOR_SINGLE_LOGIN_REPORT, LOGOUT } from '../../types'

const initialState = {
  usersReport: [],
  phrasesReport: [],
  websitesReport: [],
  supervisorActivityReport: [],
  supervisorUserReport: [],
  supervisorLoginReport: [],
  supervisorSingleLoginReport: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_USERS_REPORT: return {
      ...state,
      usersReport: action.payload
    }
    case GET_PHRASES_REPORT: return {
      ...state,
      phrasesReport: action.payload
    }
    case GET_WEBSITES_REPORT: return {
      ...state,
      websitesReport: action.payload
    }
    case GET_SUPERVISOR_REPORT: return {
      ...state,
      supervisorActivityReport: action.payload
    }
    case GET_SUPERVISOR_USER_REPORT: return {
      ...state,
      supervisorUserReport: action.payload
    }
    case GET_SUPERVISOR_LOGIN_REPORT: return {
      ...state,
      supervisorLoginReport: action.payload
    }
    case GET_SUPERVISOR_SINGLE_LOGIN_REPORT: return {
      ...state,
      supervisorSingleLoginReport: action.payload
    }
    case LOGOUT: return {
      ...state,
      ...initialState
    }
    default: return { ...state }
  }
}
